'use client';
import { Context } from 'react';
import React, { ReactNode, createContext, useMemo, useState } from 'react';

type SubmenuContextType = Context<{
  submenuOpen?: boolean;
  setSubmenuOpen: (submenuOpen: boolean) => void;
}>;

const SubmenuContext: SubmenuContextType = createContext({
  setSubmenuOpen: (submenuOpen: boolean) => {
    console.log('submenuOpen info from context', submenuOpen);
  },
});

const SubmenuProvider = ({
  openSubmenu,
  children,
}: {
  openSubmenu: boolean;
  children: ReactNode;
}) => {
  const [submenuOpen, setSubmenuOpen] = useState<boolean>(openSubmenu);
  const value = useMemo(() => ({ submenuOpen, setSubmenuOpen }), [submenuOpen]);

  return <SubmenuContext.Provider value={value}>{children}</SubmenuContext.Provider>;
};

export { SubmenuContext, SubmenuProvider };
